import { memo } from 'react'

import Svg, { G, Path, Defs, ClipPath, Rect } from 'react-native-svg'

const WorkIllustration = () => (
  <Svg width={251} height={250} viewBox="0 0 251 250" fill="none">
    <G clipPath="url(#clip0_8462_170216)">
      <Path
        d="M152.47 106.63C144.59 112.89 130.98 120.03 114.85 125.91C113.38 126.44 111.94 126.95 110.5 127.44L100.94 114.48H100.93L97.87 98.86L97.12 95.02C96.43 91.49 98.73 88.08 102.25 87.39L106.98 86.47H106.99L135.83 80.81L140.97 79.81C144.49 79.12 147.91 81.42 148.6 84.94L149.93 91.76L149.97 91.98C149.83 91.98 149.69 91.98 149.55 91.98L152.47 106.64V106.63Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M126.42 227.54C126.17 228.18 125.68 228.69 125.06 228.97C124.44 229.25 123.73 229.27 123.09 229.03C122.45 228.79 121.93 228.3 121.65 227.68L88.87 154.31C88.59 153.69 88.57 152.98 88.82 152.34C89.07 151.7 89.56 151.19 90.18 150.91C90.8 150.63 91.51 150.61 92.15 150.85C92.79 151.09 93.31 151.58 93.59 152.2L126.37 225.57H126.38C126.65 226.19 126.67 226.9 126.42 227.54Z"
        fill="#F3123C"
      />
      <Path
        d="M151.7 220.17C151.68 220.51 151.6 220.84 151.46 221.15C151.31 221.46 151.11 221.74 150.86 221.97C150.61 222.2 150.32 222.38 150 222.5C149.68 222.62 149.34 222.67 149 222.66C148.66 222.64 148.33 222.56 148.02 222.42C147.71 222.27 147.43 222.07 147.2 221.82C146.97 221.57 146.79 221.28 146.67 220.96L119.36 145.9C119.13 145.26 119.17 144.55 119.46 143.93C119.75 143.31 120.27 142.84 120.91 142.6C121.55 142.37 122.26 142.4 122.88 142.68C123.51 142.96 123.99 143.48 124.23 144.12L151.54 219.17C151.66 219.49 151.71 219.83 151.7 220.17Z"
        fill="#F3123C"
      />
      <Path
        d="M174.78 210.19C174.45 210.78 173.9 211.21 173.25 211.39C172.61 211.57 171.91 211.5 171.32 211.18C170.72 210.87 170.28 210.33 170.07 209.69L148.03 132.4C147.85 131.74 147.94 131.04 148.27 130.44C148.61 129.85 149.16 129.41 149.82 129.22C150.48 129.03 151.18 129.11 151.78 129.44C152.38 129.77 152.82 130.32 153.02 130.97L175.06 208.26H175.05C175.21 208.92 175.12 209.61 174.78 210.19Z"
        fill="#F3123C"
      />
      <Path
        d="M76.53 122.55L71.32 115.54L71.31 115.53H71.32L72.61 114.57H72.62L76.53 122.55Z"
        fill="#404040"
      />
      <Path
        d="M75.14 135.28H75.11C74.9 135.28 74.69 135.3 74.48 135.31C74.2 135.32 73.93 135.33 73.66 135.34C72.88 135.36 72.13 135.36 71.41 135.34C71.06 135.34 70.72 135.32 70.39 135.3C70.06 135.29 69.72 135.26 69.38 135.24C69.16 135.22 68.94 135.21 68.73 135.18C68.37 135.14 68.01 135.1 67.66 135.05C67.66 135.05 67.6533 135.05 67.64 135.05C66.59 134.89 65.6 134.68 64.71 134.38C64.43 134.29 64.17 134.19 63.92 134.08C62.83 133.61 61.96 132.99 61.47 132.16C61.33 131.94 61.24 131.69 61.16 131.43C61.02 130.98 60.97 130.51 61.02 129.99C61.02 129.92 61.03 129.86 61.04 129.79C61.05 129.7 61.07 129.6 61.09 129.51C61.11 129.37 61.14 129.23 61.19 129.09C61.23 128.93 61.28 128.77 61.35 128.6C61.4 128.46 61.46 128.32 61.52 128.18C61.59 128.03 61.66 127.89 61.73 127.74C61.88 127.45 62.06 127.15 62.25 126.85C62.35 126.7 62.45 126.54 62.56 126.39C62.67 126.24 62.78 126.08 62.9 125.92C63.14 125.61 63.4 125.29 63.68 124.97C64.05 124.53 64.47 124.09 64.92 123.65C65.14 123.43 65.37 123.21 65.61 122.98C66.1 122.53 66.61 122.07 67.16 121.6C67.43 121.36 67.72 121.13 68.01 120.9C68.3 120.66 68.6 120.42 68.91 120.19C69.22 119.94 69.54 119.7 69.86 119.47C70.18 119.24 70.51 119 70.85 118.75H70.86L69.59 127.67V127.73L75.14 135.27V135.28Z"
        fill="#404040"
      />
      <Path
        d="M159.76 96.6C159.78 96.85 159.78 97.1 159.76 97.36L159.73 97.57C159.71 97.67 159.7 97.76 159.68 97.86C159.62 98.13 159.54 98.41 159.43 98.7C159.4 98.77 159.37 98.85 159.34 98.93C159.31 99.01 159.27 99.09 159.24 99.17C159.22 99.21 159.2 99.25 159.18 99.29C159.17 99.32 159.15 99.36 159.13 99.4C159.09 99.48 159.05 99.56 159 99.64C158.95 99.74 158.89 99.84 158.83 99.94C158.8 100.02 158.75 100.09 158.71 100.16C158.61 100.32 158.52 100.47 158.41 100.63C158.14 101.03 157.83 101.44 157.49 101.86C156.62 102.94 155.58 103.99 154.52 104.92C154.35 105.07 154.18 105.22 154 105.38C153.74 105.61 153.48 105.83 153.22 106.04C152.97 106.25 152.72 106.45 152.47 106.65V106.63L149.55 91.97C149.69 91.97 149.83 91.97 149.97 91.99C150.09 91.99 150.21 91.99 150.32 92C150.56 92.01 150.81 92.02 151.07 92.04C152.5 92.13 154.1 92.34 155.52 92.76C155.85 92.84 156.16 92.95 156.46 93.07C156.52 93.09 156.58 93.11 156.64 93.14C156.9 93.25 157.14 93.36 157.37 93.48C157.49 93.54 157.61 93.61 157.72 93.68C157.98 93.84 158.22 94.02 158.44 94.2C158.56 94.3 158.67 94.4 158.77 94.51C158.87 94.61 158.97 94.72 159.05 94.83C159.05 94.83 159.057 94.8366 159.07 94.85C159.15 94.95 159.22 95.05 159.28 95.16C159.35 95.28 159.41 95.39 159.46 95.51C159.52 95.62 159.57 95.74 159.6 95.86C159.65 95.99 159.68 96.12 159.71 96.26C159.71 96.27 159.71 96.28 159.71 96.29C159.71 96.33 159.72 96.38 159.73 96.43C159.74 96.48 159.74 96.54 159.75 96.6H159.76Z"
        fill="#404040"
      />
      <Path
        d="M100.57 113.97V113.99L97.77 110.19L97.16 109.36L94.62 105.91V105.89C95.92 105.32 97.27 104.75 98.62 104.2V104.22H98.63L100.56 113.96H100.57V113.97Z"
        fill="#404040"
      />
      <Path
        d="M191.21 206.81L159.72 96.29C159.72 96.29 159.73 96.38 159.74 96.43C159.75 96.48 159.75 96.54 159.76 96.6C159.78 96.85 159.78 97.1 159.76 97.36L159.73 97.57C159.71 97.67 159.7 97.76 159.68 97.86C159.62 98.13 159.54 98.41 159.43 98.7C159.4 98.77 159.37 98.85 159.34 98.93C159.31 99.01 159.27 99.09 159.24 99.17C159.22 99.21 159.2 99.25 159.18 99.29C159.17 99.32 159.15 99.36 159.13 99.4C159.09 99.48 159.05 99.56 159 99.64C158.95 99.74 158.89 99.84 158.83 99.94C158.8 100.02 158.75 100.09 158.71 100.16C158.61 100.32 158.52 100.47 158.41 100.63C158.14 101.03 157.83 101.44 157.49 101.86C156.62 102.94 155.58 103.99 154.52 104.92C154.35 105.07 154.18 105.22 154 105.38C153.85 105.51 153.69 105.64 153.53 105.77C153.43 105.87 153.33 105.96 153.22 106.04C152.97 106.25 152.72 106.45 152.47 106.65V106.63C144.59 112.89 130.98 120.03 114.85 125.91C113.38 126.44 111.94 126.95 110.5 127.44H110.49C96.79 132.08 84.2 134.78 75.14 135.28H75.11C74.9 135.28 74.69 135.3 74.48 135.31C74.2 135.32 73.93 135.33 73.66 135.34C72.88 135.36 72.13 135.36 71.41 135.34C71.06 135.34 70.72 135.32 70.39 135.3C70.04 135.29 69.71 135.27 69.38 135.24C69.16 135.22 68.94 135.21 68.73 135.18C68.36 135.15 68.01 135.1 67.66 135.05C67.66 135.05 67.6533 135.05 67.64 135.05C66.59 134.91 65.65 134.7 64.84 134.43C64.8 134.42 64.75 134.4 64.71 134.38C64.43 134.29 64.17 134.19 63.92 134.08C62.83 133.61 61.96 132.99 61.47 132.16L108.34 236.96C115.92 257.75 198.79 227.58 191.21 206.8V206.81ZM126.42 227.54C126.17 228.18 125.68 228.69 125.06 228.97C124.44 229.25 123.73 229.27 123.09 229.03C122.45 228.79 121.93 228.3 121.65 227.68L88.87 154.31C88.59 153.69 88.57 152.98 88.82 152.34C89.07 151.7 89.56 151.19 90.18 150.91C90.8 150.63 91.51 150.61 92.15 150.85C92.79 151.09 93.31 151.58 93.59 152.2L126.37 225.57H126.38C126.65 226.19 126.67 226.9 126.42 227.54ZM151.46 221.15C151.31 221.46 151.11 221.74 150.86 221.97C150.61 222.2 150.32 222.38 150 222.5C149.68 222.62 149.34 222.67 149 222.66C148.66 222.64 148.33 222.56 148.02 222.42C147.71 222.27 147.43 222.07 147.2 221.82C146.97 221.57 146.79 221.28 146.67 220.96L119.36 145.9C119.13 145.26 119.17 144.55 119.46 143.93C119.75 143.31 120.27 142.84 120.91 142.6C121.55 142.37 122.26 142.4 122.88 142.68C123.51 142.96 123.99 143.48 124.23 144.12L151.54 219.17C151.66 219.49 151.71 219.83 151.7 220.17C151.68 220.51 151.6 220.84 151.46 221.15ZM174.78 210.19C174.45 210.78 173.9 211.21 173.25 211.39C172.61 211.57 171.91 211.5 171.32 211.18C170.72 210.87 170.28 210.33 170.07 209.69L148.03 132.4C147.85 131.74 147.94 131.04 148.27 130.44C148.61 129.85 149.16 129.41 149.82 129.22C150.48 129.03 151.18 129.11 151.78 129.44C152.38 129.77 152.82 130.32 153.02 130.97L175.06 208.26H175.05C175.21 208.92 175.12 209.61 174.78 210.19Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M61.28 131.75C61.31 131.82 61.35 131.89 61.38 131.96L61.47 132.17"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M110.5 127.44H110.49C96.79 132.08 84.2 134.78 75.14 135.28L69.58 127.74V127.68L76.54 122.57V122.55L72.63 114.57L91.02 101.02L94.62 105.89V105.91L97.17 109.36L97.78 110.19L100.58 113.99V113.97V113.99L100.94 114.47H100.95L110.51 127.44H110.5Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M76.54 122.56V122.57L69.59 127.68L70.86 118.76V118.74L71.32 115.54L76.53 122.55L76.54 122.56Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M72.62 114.57H72.61L71.32 115.53V115.54"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M70.86 118.76H70.85L69.57 127.69L69.56 127.74L75.13 135.28"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M94.61 105.91H94.62L97.16 109.36"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M97.77 110.19L100.56 113.96L100.57 113.97"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M110.51 127.45L110.5 127.44"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M75.14 135.29V135.28"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M69.59 127.68L69.57 127.69L69.53 127.72"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M72.62 114.57V114.56"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M149.97 91.98C150.08 91.98 150.2 91.99 150.32 92C150.56 92 150.81 92.02 151.07 92.04C152.5 92.13 154.1 92.34 155.52 92.76C155.85 92.84 156.16 92.95 156.46 93.07C156.52 93.09 156.58 93.11 156.64 93.14C156.9 93.24 157.14 93.35 157.37 93.48C158.06 93.84 158.64 94.28 159.05 94.83C159.05 94.83 159.057 94.8366 159.07 94.85C159.15 94.95 159.22 95.05 159.28 95.16C159.35 95.27 159.42 95.39 159.46 95.51C159.52 95.62 159.57 95.74 159.6 95.86C159.65 95.99 159.68 96.12 159.71 96.26C159.71 96.27 159.71 96.28 159.71 96.29"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M159.76 96.6001C159.87 97.7901 159.4 99.1501 158.41 100.63C158.14 101.03 157.83 101.44 157.49 101.86C156.69 102.84 155.7 103.86 154.52 104.92C153.89 105.48 153.2 106.05 152.47 106.63"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M74.48 135.31C74.2 135.31 73.93 135.33 73.66 135.34"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M63.92 134.09C62.69 133.55 61.84 132.83 61.38 131.96C61.35 131.89 61.31 131.82 61.28 131.75C61.05 131.22 60.96 130.64 61.02 130C61.02 129.93 61.02 129.87 61.04 129.8C61.05 129.71 61.07 129.61 61.09 129.52C61.11 129.38 61.14 129.24 61.19 129.1C61.23 128.94 61.28 128.78 61.35 128.61C61.51 128.15 61.75 127.66 62.05 127.16C62.47 126.46 63.01 125.73 63.68 124.98C64.05 124.54 64.47 124.1 64.92 123.66C65.14 123.42 65.37 123.2 65.61 122.99C66.09 122.53 66.61 122.07 67.16 121.61C67.43 121.37 67.72 121.14 68.01 120.91C68.3 120.67 68.6 120.43 68.91 120.2C69.22 119.95 69.54 119.71 69.86 119.48C70.18 119.23 70.51 118.99 70.85 118.75C70.85 118.74 70.86 118.74 70.86 118.74"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M94.61 105.91C95.92 105.34 97.27 104.77 98.62 104.22"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M98.63 104.23L100.58 113.99"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M126.42 227.54C126.17 228.18 125.68 228.69 125.06 228.97C124.44 229.25 123.73 229.27 123.09 229.03C122.45 228.79 121.93 228.3 121.65 227.68L88.87 154.31C88.59 153.69 88.57 152.98 88.82 152.34C89.07 151.7 89.56 151.19 90.18 150.91C90.8 150.63 91.51 150.61 92.15 150.85C92.79 151.09 93.31 151.58 93.59 152.2L126.37 225.57H126.38C126.65 226.19 126.67 226.9 126.42 227.54V227.54Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinejoin="round"
      />
      <Path
        d="M151.7 220.17C151.68 220.51 151.6 220.84 151.46 221.15C151.31 221.46 151.11 221.74 150.86 221.97C150.61 222.2 150.32 222.38 150 222.5C149.68 222.62 149.34 222.67 149 222.66C148.66 222.64 148.33 222.56 148.02 222.42C147.71 222.27 147.43 222.07 147.2 221.82C146.97 221.57 146.79 221.28 146.67 220.96L119.36 145.9C119.13 145.26 119.17 144.55 119.46 143.93C119.75 143.31 120.27 142.84 120.91 142.6C121.55 142.37 122.26 142.4 122.88 142.68C123.51 142.96 123.99 143.48 124.23 144.12L151.54 219.17C151.66 219.49 151.71 219.83 151.7 220.17V220.17Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinejoin="round"
      />
      <Path
        d="M174.78 210.19C174.45 210.78 173.9 211.21 173.25 211.39C172.61 211.57 171.91 211.5 171.32 211.18C170.72 210.87 170.28 210.33 170.07 209.69L148.03 132.4C147.85 131.74 147.94 131.04 148.27 130.44C148.61 129.85 149.16 129.41 149.82 129.22C150.48 129.03 151.18 129.11 151.78 129.44C152.38 129.77 152.82 130.32 153.02 130.97L175.06 208.26H175.05C175.21 208.92 175.12 209.61 174.78 210.19V210.19Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinejoin="round"
      />
      <Path
        d="M106.08 81.3401L108.04 92.4701"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M135.02 76.23L136.98 87.36"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M97.7 98.8901L148.9 89.8501"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M100.94 114.5V114.48"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M152.79 106.35L149.97 91.99"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M159.17 77.8901C167.02 73.5301 175.92 71.4201 184.89 71.8101C185.1 71.8101 185.31 71.7701 185.5 71.6701C185.69 71.5801 185.86 71.4401 185.99 71.2701C186.12 71.1001 186.21 70.9101 186.25 70.7001C186.29 70.4901 186.28 70.2801 186.22 70.0701C185.61 67.9601 185.29 66.7201 184.7 64.6301C178.86 65.7001 172.9 66.6301 167.41 69.1401C172.35 65.6701 177.53 61.9401 183.35 59.7601C182.76 57.6201 182.39 56.3401 181.81 54.2001C181.76 54.0001 181.66 53.8101 181.52 53.6501C181.38 53.4901 181.2 53.3701 181.01 53.2901C180.81 53.2101 180.6 53.1801 180.39 53.2001C180.18 53.2201 179.98 53.2801 179.8 53.4001C170.55 58.9701 162.82 66.7301 157.31 76.0101C157.16 76.2701 157.1 76.5801 157.14 76.8701C157.18 77.1701 157.32 77.4501 157.53 77.6601C157.74 77.8701 158.02 78.0101 158.32 78.0501C158.62 78.0901 158.92 78.0301 159.19 77.8801H159.17V77.8901Z"
        fill="#F3123C"
      />
      <Path
        d="M159.17 77.8901C167.02 73.5301 175.92 71.4201 184.89 71.8101C185.1 71.8101 185.31 71.7701 185.5 71.6701C185.69 71.5801 185.86 71.4401 185.99 71.2701C186.12 71.1001 186.21 70.9101 186.25 70.7001C186.29 70.4901 186.28 70.2801 186.22 70.0701C185.61 67.9601 185.29 66.7201 184.7 64.6301C178.86 65.7001 172.9 66.6301 167.41 69.1401C172.35 65.6701 177.53 61.9401 183.35 59.7601C182.76 57.6201 182.39 56.3401 181.81 54.2001C181.76 54.0001 181.66 53.8101 181.52 53.6501C181.38 53.4901 181.2 53.3701 181.01 53.2901C180.81 53.2101 180.6 53.1801 180.39 53.2001C180.18 53.2201 179.98 53.2801 179.8 53.4001C170.55 58.9701 162.82 66.7301 157.31 76.0101C157.16 76.2701 157.1 76.5801 157.14 76.8701C157.18 77.1701 157.32 77.4501 157.53 77.6601C157.74 77.8701 158.02 78.0101 158.32 78.0501C158.62 78.0901 158.92 78.0301 159.19 77.8801H159.17V77.8901Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M167.41 69.1501C190.33 56.4901 214.13 57.1301 224.82 68.1801C244.04 88.0601 224.32 138.32 180.76 180.43C137.2 222.54 86.33 240.57 67.09 220.69C55.19 208.39 58.21 184.42 72.58 157.99"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M97.29 61.82C97.21 61.91 97.12 61.99 97.03 62.06C96.42 62.64 95.81 63.21 95.23 63.76C95.13 63.85 95.04 63.94 94.95 64.02C94.6 64.34 94.27 64.65 93.94 64.95C93.62 65.25 93.31 65.53 93.01 65.8C92.39 66.36 91.8 66.88 91.25 67.37C91.2 67.42 91.15 67.46 91.1 67.51C90.78 67.78 90.48 68.04 90.18 68.3C90.01 68.45 89.85 68.59 89.7 68.72C87.87 70.27 84.99 72.59 81.46 75.26C80.96 75.64 80.44 76.02 79.92 76.42C79.38 76.82 78.84 77.22 78.29 77.62C77.74 78.03 77.18 78.43 76.61 78.85C76.32 79.06 76.03 79.27 75.74 79.48C75.16 79.89 74.57 80.31 73.98 80.74C73.37 81.16 72.76 81.59 72.15 82.01C71.24 82.64 70.31 83.28 69.36 83.92C69.36 83.92 69.3567 83.92 69.35 83.92C68.73 84.34 68.1 84.76 67.46 85.19C67.14 85.41 66.81 85.62 66.49 85.82C65.53 86.44 64.57 87.06 63.6 87.68C55.83 92.56 47.88 96.77 41.8 98.27C39.01 98.95 36.62 99.06 34.82 98.4C34.2 98.17 33.65 97.85 33.18 97.43C33.15 97.41 33.12 97.38 33.09 97.35C32.96 97.23 32.84 97.11 32.73 96.98C31.3 95.29 31.37 92.47 32.72 88.83C33.1 87.78 33.6 86.66 34.2 85.48C34.49 84.89 34.82 84.28 35.17 83.67C35.35 83.36 35.53 83.04 35.71 82.73C36.09 82.09 36.48 81.45 36.9 80.79C37.94 79.13 39.14 77.4 40.48 75.61C42.08 73.46 43.87 71.21 45.85 68.89C46.18 68.5 46.52 68.12 46.85 67.73C48.2 66.17 49.63 64.59 51.14 62.98L52.83 64.94H52.84L80.24 41.63L91.89 31.72L90.21 29.75H90.22C90.22 29.75 90.23 29.75 90.23 29.74C92.76 28.05 95.22 26.48 97.6 25.06C108.95 18.25 118.4 14.67 123.57 15.46C124.48 15.59 125.26 15.87 125.9 16.29C126.22 16.5 126.5 16.75 126.74 17.04C133.16 24.54 111.49 48.29 97.31 61.82H97.29Z"
        fill="#404040"
      />
      <Path
        d="M91.88 31.7201L52.81 64.9201L49.3 60.7901L88.37 27.5601L91.88 31.7201Z"
        fill="#404040"
      />
      <Path
        d="M91.88 31.7201L52.81 64.9201L49.3 60.7901L88.37 27.5601L91.88 31.7201V31.7201Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M91.88 31.72L99.62 40.82L105.27 36.02"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M52.81 64.9199L60.2 73.6099L54.64 78.3399"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M51.13 62.97H51.12C49.62 64.59 48.19 66.17 46.83 67.73C46.5 68.12 46.16 68.5 45.83 68.89C43.86 71.21 42.06 73.46 40.46 75.61C39.13 77.4 37.93 79.13 36.88 80.79C36.46 81.45 36.07 82.09 35.69 82.73C35.51 83.04 35.33 83.36 35.15 83.67C34.81 84.28 34.48 84.89 34.18 85.48C33.59 86.66 33.09 87.78 32.7 88.83C31.36 92.47 31.29 95.3 32.72 96.98C32.81 97.08 32.9 97.18 33.01 97.27C33.05 97.33 33.1 97.38 33.16 97.43"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M126.75 17.04C126.5 16.75 126.21 16.49 125.88 16.29C125.24 15.87 124.46 15.59 123.55 15.46C118.37 14.69 108.92 18.27 97.58 25.06C95.2 26.48 92.74 28.05 90.21 29.74C90.21 29.75 90.2 29.75 90.2 29.75"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M98.39 78.91C72.43 100.97 46.9 113.63 41.41 107.15L33.07 97.35C33.07 97.35 33.13 97.41 33.16 97.43C33.63 97.85 34.18 98.17 34.8 98.4C36.59 99.07 38.99 98.96 41.78 98.27C47.86 96.78 55.81 92.57 63.58 87.68C64.55 87.07 65.51 86.45 66.47 85.82C66.79 85.62 67.12 85.41 67.44 85.19C68.08 84.77 68.71 84.35 69.33 83.92C69.33 83.92 69.3333 83.92 69.34 83.92C70.29 83.29 71.22 82.65 72.13 82.01C72.74 81.59 73.35 81.16 73.96 80.74C74.55 80.32 75.14 79.9 75.72 79.48C76.01 79.27 76.3 79.06 76.59 78.85C77.16 78.44 77.72 78.03 78.27 77.62C78.82 77.22 79.36 76.82 79.9 76.42C80.42 76.03 80.94 75.64 81.44 75.26C84.97 72.59 87.85 70.27 89.68 68.72C89.83 68.59 89.99 68.45 90.16 68.3C90.45 68.06 90.76 67.79 91.08 67.51C91.13 67.46 91.18 67.42 91.23 67.37C91.77 66.9 92.36 66.37 92.99 65.8C93.29 65.53 93.6 65.25 93.92 64.95C94.25 64.65 94.58 64.35 94.93 64.02C95.02 63.94 95.11 63.85 95.21 63.76C95.79 63.22 96.39 62.66 97.01 62.06C97.1 61.99 97.19 61.91 97.27 61.82C111.11 48.67 133.32 24.77 126.73 17.04L135.4 27.23C140.91 33.69 124.3 56.84 98.37 78.91H98.39Z"
        fill="#F5F5F5"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M33.07 97.35L33.01 97.27L32.74 96.96"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M24.69 157.86C24.87 158.36 24.9 158.9 24.77 159.42C24.64 159.94 24.36 160.4 23.97 160.76C23.58 161.12 23.09 161.35 22.56 161.43C22.03 161.51 21.5 161.43 21.01 161.21C20.53 160.98 20.12 160.62 19.85 160.17C19.57 159.71 19.44 159.19 19.47 158.66C19.49 158.13 19.68 157.62 19.99 157.19C20.31 156.76 20.74 156.44 21.24 156.26C21.57 156.14 21.92 156.09 22.28 156.1C22.63 156.1 22.98 156.2 23.3 156.35C23.62 156.5 23.91 156.71 24.15 156.97C24.39 157.23 24.57 157.54 24.69 157.87V157.86Z"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M169.33 6.46997L174.06 19.51"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M178.22 10.6199L165.18 15.3499"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M227.71 184.48L208.54 191.42"
        stroke="#2E2E2E"
        strokeWidth={0.94}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_8462_170216">
        <Rect width={213.65} height={238.44} fill="white" transform="translate(19 6)" />
      </ClipPath>
    </Defs>
  </Svg>
)

export const Work = memo(WorkIllustration)
